import React, { Fragment } from 'react';

import { withStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { WithStyles } from '@material-ui/styles';

import { WithTranslation, withTranslation, TransProps } from 'react-i18next';

import { AppState, IPageState, store, Actions, PanelState } from '../../appredux';

import { connect, Provider } from 'react-redux';

import ReactDOM from 'react-dom';

import theme from '../../themes/themes';
import themeBlue from '../../themes/themesBlue';
import themeGreen from '../../themes/themesGreen';
import themeBrownLight from '../../themes/themesBrownLight';
import themeBrownDark from '../../themes/themesBrownDark';
import Notifier from '../Notifier';

export type Content = {
    message: string,
    messageBoldPrimary?: string
}

//PM 2021-08-13
//usuniecie opcjonalnosci reservationId
type DialogProps = {
    platnosc: boolean,
    success: boolean,
    page: IPageState,
}

type DialogState = {
}

class Notifier1 extends React.Component<WithTranslation & DialogProps & TransProps & WithStyles<typeof styles>, DialogState> {

    constructor(props: WithTranslation & DialogProps & TransProps & WithStyles<typeof styles>) {
        super(props, {});
        this.state = {

        };
    }

    componentDidUpdate(prevProps: DialogProps) {
        if (prevProps.platnosc == false && this.props.platnosc == true) {
            this.openNotifier()
        };
    }

    openNotifier = async () => {

        ReactDOM.render(
            <Provider store={store}>
                <MuiThemeProvider
                    theme={this.props.page.theme === "1" ?
                        theme : this.props.page.theme === "2" ?
                            themeBlue : this.props.page.theme === "3" ?
                                themeBrownDark : this.props.page.theme === "4" ?
                                    themeBrownLight : themeGreen}
                >
                    <Notifier
                        //messagePart1={t("Your reservation has number")}                     
                        //messagePart2={t("Thank You for reservation. Confirmation has been sent to your e-mail address")} 
                        paymentId={""}// {this.props.page.notifierData.paymentId}
                        reservationId={this.props.page.notifierData.reservationId}
                        dialogContent={this.props.page.notifierData.dialogContent}
                        dialogContentFailure={this.props.page.notifierData.dialogContentFailure}
                        title={"Sukces"}
                        titleFailure={"Porażka"}
                        reservation={this.props.page.notifierData.reservation}
                        success={this.props.success}
                        handleClose={this.props.page.notifierData.handleClose}
                        roomDescription={this.props.page.notifierData.roomDescription} />
                </MuiThemeProvider>
            </Provider>,
            document.getElementById("dialog"));
        await store.dispatch(Actions.pageState.setNotifierOpen());
    }

    //PM 2021-10-20
    //await store.dispatch(Actions.pageState.setLangPhone({ flag: this.props.page.lang, prefix: '' }));
    handleCloseWithoutModal = async () => {
        await store.dispatch(Actions.pageState.resetZmienianyPobyt());
        await store.dispatch(Actions.pageState.setCzyPobytZmieniany(false));
        await store.dispatch(Actions.pageState.setLangPhone({ flag: this.props.page.lang, prefix: '' }));
        await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
    }


    render() {
        const { classes } = this.props;

        return (
            <>

            </>
        );

    }
}

const styles = (theme: Theme) => ({

});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Notifier1)));



